import statistic from './statistic'

export default {
  settings: {
    hasOvertime: true,
    hideTimerOnOvertime: true
  },
  actionTypes: {
    score: [
      'PT1',
      'PT2',
      'PT3',
      'CORRECTION_1_UP',
      'CORRECTION_1_DOWN',
      'ADJUST_SCORE',
      'THROW_POINT_1_POINT',
      'THROW_POINT_2_POINT',
      'THROW_POINT_3_POINT',
      'THROW_POINT_4_POINT',
      'THROW_POINT_5_POINT',
      'THROW_POINT_6_POINT',
      'THROW_POINT_7_POINT',
      'THROW_POINT_8_POINT',
      'THROW_POINT_9_POINT',
      'THROW_POINT_10_POINT'
    ],
    foul: ['FOUL', 'ADJUST_FOULS', 'FOUL_D', 'FOUL_U', 'TECHNICAL_FOUL']
  },
  modules: {
    info: [
      'timer',
      {
        type: 'periods',
        props: {
          className: 'liveCardPeriods__slider_left'
        }
      }
    ],
    score: {
      component: 'score-component'
    },
    fieldScheme: {
      component: 'match-center'
    },
    statistic,
    eventLog: true
  },
  storeScheme: {
    shotoutOnly: false,
    fouls: {
      home: 0,
      away: 0
    },
    score: {
      home: 0,
      away: 0
    },
    shootoutsLog: {
      home: [],
      away: []
    },
    getOvertimePeriodName: () => 'OT'
  }
}
